import React from 'react';
import Form from 'react-bootstrap/Form';
import styled from "styled-components";

const SearchComponent = () => {
    return (
        <SearchComponentMobileStyle className={'form-area'}  >
            <Form>
                <Form.Group controlId="formBasicEmail">
                    <Form.Control className={'border-top-0 border-left-0 border-right-0'} type="text" placeholder="Search your items"/>
                </Form.Group>
            </Form>
        </SearchComponentMobileStyle>
    );
};

const SearchComponentMobileStyle = styled.div`
    input {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.5);
        width: 100%;
        margin-left: 15px;
        background-color: transparent;


        &::placeholder {
            color: rgba(0, 0, 0, 0.5);
        }

        &:focus {
            border-bottom: 1px solid rgb(127, 127, 127);
        }
    }
`

export default SearchComponent;